module.exports = __webpack_public_path__ + "img/ic-image-default.f5865448.svg";